import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { useSettings } from "../settings";

export const Footer = () => {
  const { settings } = useSettings();
  const socials = [
    { label: "Facebook", href: settings.facebook_url, Icon: Facebook },
    { label: "Instagram", href: settings.instagram_url, Icon: Instagram },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black px-5 py-12 sm:px-8 lg:px-12">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
        <div className="flex items-center gap-4">
          <Logo className="h-20 w-20" />
          <div>
            <p className="font-heading text-lg font-bold tracking-[0.18em]">{settings.company_name.toUpperCase()}</p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-white/40">
              Pre-Engineered Metal Buildings &amp; Erecting
            </p>
          </div>
        </div>

        <div className="text-xs uppercase tracking-[0.2em] text-white/50">
          <p>{settings.phone}</p>
          <p className="mt-1">{settings.email}</p>
        </div>

        <div className="flex items-center gap-3">
          {socials.map(({ label, href, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-social-${label.toLowerCase()}`}
              aria-label={label}
              className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/60 transition-colors duration-300 hover:border-volt hover:text-volt"
            >
              <Icon className="h-4 w-4" strokeWidth={1.5} />
            </a>
          ))}
        </div>
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6 text-[10px] uppercase tracking-[0.25em] text-white/30">
        <p>© {new Date().getFullYear()} {settings.company_name}. All rights reserved.</p>
        <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-white/60">
          Owner Login
        </Link>
      </div>
    </footer>
  );
};
